var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.9;}.b{fill:none;stroke:#fff;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-983.5 -13.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 20,
    transform: "translate(983.5 13.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 20,
    transform: "translate(983.5 21.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 20,
    transform: "translate(983.5 29.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon_menu.7ac37460d1413a25e4cc6d669f11c005.svg";
export { ForwardRef as ReactComponent };